var render = function render(){var _vm=this,_c=_vm._self._c;return _c('w-icon-wrapper',{attrs:{"height":18,"width":18,"icon-name":"work-checkbox-unselect-icon","view-box":"0 0 18 18"}},[_c('rect',{attrs:{"id":"Checkbox_Unselected","width":"18","height":"18","rx":"2","fill":"currentColor"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }